import env from './env'
import axios from 'axios'
import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root'))

if (env === 'production') {
  axios.defaults.baseURL = 'https://gotlzlvrsb.execute-api.us-east-1.amazonaws.com'
} else {
  axios.defaults.baseURL = 'http://localhost:3001'
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
